import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  addProductToCart,
  updateProductInCart,
  removeProductInCart,
} from './Actions/GtmEEC.action';

const GtmEnhancedEcomListener = () => {
  const dispatch = useDispatch();
  const [savedQuantity, setSavedQuantity] = useState(-1);
  const [savedOrderRows, setSavedOrderRows] = useState(-1);
  const elementRef = useRef(null);
  const { quantity, orderRows } = useSelector((state) => state.cart);

  useEffect(() => {
    if (savedQuantity !== -1 && savedOrderRows) {
      // Compare objects
      // Added to Cart

      // ...any Article been Removed?
      //else if (savedOrderRows.length > orderRows.length) {
      //    const removedArticle = savedOrderRows.find(changed => !orderRows.some(saved => changed.articleNumber === saved.articleNumber));
      //    if (removedArticle) {
      //        // Removing article
      //    }
      //}
      if (orderRows.length > savedOrderRows.length) {
        // Adding
        const changedArticle = orderRows.find(
          (changed) =>
            !savedOrderRows.some(
              (saved) => changed.articleNumber === saved.articleNumber
            )
        );
        if (changedArticle) {
          const quantity = changedArticle?.quantity || 1;
          dispatch(
            addProductToCart(changedArticle.articleNumber, parseInt(quantity))
          );
        }
      } else {
        // Update
        const changedArticle = orderRows.find((changed) =>
          savedOrderRows.some(
            (saved) =>
              changed.articleNumber === saved.articleNumber &&
              changed.quantity !== saved.quantity
          )
        );
        const oldValuesArticle = savedOrderRows.find(
          (x) =>
            x.articleNumber != null &&
            changedArticle?.articleNumber != null &&
            x.articleNumber === changedArticle.articleNumber
        );
        if (oldValuesArticle != null) {
          const quantity = changedArticle?.quantity || 1;
          dispatch(
            updateProductInCart(
              changedArticle.rowSystemId,
              parseInt(quantity),
              parseInt(oldValuesArticle.quantity || 1)
            )
          );
        } else if (orderRows.length < savedOrderRows.length) {
          const removedArticle = savedOrderRows.find(
            (changed) =>
              !orderRows.some(
                (old) => old.articleNumber === changed.articleNumber
              )
          );
          // Removing
          if (removedArticle) {
            dispatch(removeProductInCart(removedArticle));
          }

          //if (!oldValuesArticle) {
          //    console.log("Not in list -> Add -> Changed",changedArticle);
          //}
          //else {
          //    console.log("IS IN LIST! -> Update -> Changed", changedArticle);
          //}
          //if (quantity > oldValuesArticle.quantity) {
          //    // Adding
          //    const amountAdded = changedArticle.quantity - oldValuesArticle.quantity;
          //    console.log("adding: ", amountAdded);
          //}
          //else if (quantity < oldValuesArticle.quantity) {
          //    // Removing
          //    const amountRemoved = oldValuesArticle.quantity - quantity;
          //    console.log("Removing: ", amountRemoved);
          //}
        }
      }
    }
    setSavedQuantity(quantity);
    setSavedOrderRows(orderRows);
  }, [quantity]);

  return null;
};
export default GtmEnhancedEcomListener;
